import React from "react";
import { useState, useEffect } from "react";
import { Box, Typography,Snackbar } from "@material-ui/core";
import useStyles from "./PatientInterests.style";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import { useTranslation } from "react-i18next";
import {MobileAlert} from '../components'



function PatientInterests(props) {
  const { t } = useTranslation();
  const classes = useStyles();
 
  const [error, setError] = useState(false)
  
  useEffect(()=>{
    props.selectedItems.length>0 && setError(false)
  },[props.selectedItems])

  

  const handleMessageClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}

		setError(false);
	};

  
 

  return (
    <Box className={classes.mainContainer}>
      <Typography variant="h1" className={classes.mainHeading}>
      {t('common.patientInterestsTitle')}
      </Typography>
      <Box>
        <List
          sx={{
            width: "100%",
            marginTop: "10%",
          }}
          component="nav"
          aria-labelledby="nested-list-subheader"
        >
          {props.initialInterestsData.map((val, i) => {
            return (
              <ListItemButton
                onClick={()=>props.handleOnClick(i)}
                sx={{
                  textAlign: "center",
                  color: "#4A618A",
                  transition: "0.1s ease-in",
                  borderRadius:"4px",
                  borderLeft:props.selectedIndex.includes(i) ? "3px solid #1FA19D" :'3px solid white' , 
                  borderRight:props.selectedIndex.includes(i)? "3px solid #1FA19D" :'3px solid white',  
                  backgroundColor:props.selectedIndex.includes(i) ? "#e2e2e2" :'white',
                  "&:hover": { 
                    backgroundColor: "#f5f5f5", 
                    borderLeft:"3px solid #1FA19D", 
                    borderRight:"3px solid #1FA19D", 
                    scale:"103%",
                },
                }}
                key={val.id}
              >
                <ListItemText
                  sx={{ width: "100%", height: "100%" }}
                  primary={val.item}
                />
              </ListItemButton>
            );
          })}
        </List>
      </Box>
      <Snackbar open={error} autoHideDuration={6000} onClose={handleMessageClose}>
				<MobileAlert onClose={handleMessageClose} severity="error">
					{"Please select at least one option"}
				</MobileAlert>
			</Snackbar>
      <button className={classes.SubmitBtn} 
      onClick={()=>{
        if(props.selectedItems.length===0){
          setError(true)
        }else{
          setError(false)
          props.handleGoToDashboard()
        }
          
        }}>{"➜"}</button>
    </Box>
  );
}

export default PatientInterests;


